import { Component, OnInit, ViewChild } from '@angular/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { SignInPage } from '../../pages/sign-in/sign-in.page';
import { Router } from '@angular/router';
import { SignUpPage } from '../../pages/sign-up/sign-up.page';
import { PopoverController, ModalController } from '@ionic/angular';
import { HomePage } from '../../pages/home/home.page';
import { MyOrdersPage } from '../../pages/my-orders/my-orders.page';
import { AccountPage } from '../../pages/account/account.page';
import { PrivacyPage } from '../../pages/privacy/privacy.page';
import { TosPage } from '../../pages/tos/tos.page';
import { ImpressumPage } from '../../pages/impressum/impressum.page';
import { MatSnackBar } from '@angular/material/snack-bar';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { NavigationService } from 'src/app/services/navigation.service';
import { Api } from 'src/smoothr-web-app-core/api/api';
enum Language {
	GreatBritain = 'en',
	German = 'de',
	Czech = 'cr',
}

@Component({
	selector: 'app-menu-modal',
	templateUrl: './menu-modal.component.html',
	styleUrls: ['./menu-modal.component.scss'],
})
export class MenuModalComponent extends RepositoryDirective implements OnInit {
	environment = environment;
	languageEnum = Language;

	checkIfVenueExistImpressum;
	constructor(
		public repository: RepositoryService,
		private router: Router,
		private modalController: ModalController,
		private snackbarCtrl: MatSnackBar,
		public translate: TranslateService,
		private navigationService: NavigationService
	) {
		super(repository);
	}
	ngOnInit(): void {
		super.ngOnInit();
		this.checkIfVenueExistImpressum = '';
		if (this.repository._venue && this.repository._order) {
			if (this.repository._venue) {
				const ifUrlIncludes = this.router.url.includes('home') || this.router.url.includes('map');
				console.log(ifUrlIncludes, this.router.url, !this.repository._venue?.legal?.imprint && !ifUrlIncludes);
				if (!this.repository._venue?.legal?.imprint && !ifUrlIncludes) {
					this.checkToShowData(this.repository._venue._id);
				}
				return;
			} else {
				this.checkIfVenueExistImpressum = '';
			}
		}
	}

	openAccessibility() {}

	private async checkToShowData(venueId: string) {
		try {
			const legal = (await Api.getLegal(venueId)).data;
			if (legal.type === 'pdf') {
				this.checkIfVenueExistImpressum = legal.imprint;
			}
		} catch (e) {
			console.error('Error while getting legal information');
			console.error(e);
		}
	}
	async signIn() {
		try {
			await this.modalController.dismiss();
			await this.modalController.dismiss();
			await this.navigationService.signIn();
		} catch (e) {
			await this.navigationService.signIn();
		}
	}

	async signUp() {
		try {
			await this.modalController.dismiss();
			await this.modalController.dismiss();
			await this.navigationService.signUp();
		} catch (e) {
			await this.navigationService.signUp();
		}
	}

	async mySpace() {
		try {
			await this.modalController.dismiss();
			await this.modalController.dismiss();
			await this.navigationService.account();
		} catch (e) {
			await this.navigationService.account();
		}
	}

	async myOrders() {
		try {
			await this.modalController.dismiss();
			await this.modalController.dismiss();

			await this.navigationService.myOrders();
		} catch (e) {
			await this.navigationService.myOrders();
		}
	}

	async logout() {
		try {
			this.repository.customerAuth.emit(null);
			this.snackbarCtrl.open(this.translate.instant('menu_popover.logout_success'), null, {
				duration: 2000,
			});
		} catch (e) {
			this.snackbarCtrl.open(this.translate.instant('menu_popover.logout_error'), null, {
				duration: 2000,
			});
		}
		await this.modalController.dismiss();
	}

	async home() {
		await this.modalController.dismiss();
		await this.navigationService.home();
	}

	async privacy() {
		try {
			await this.modalController.dismiss();
			await this.modalController.dismiss();
			await this.navigationService.privacy();
		} catch (e) {
			await this.navigationService.privacy();
		}
	}

	async tos() {
		await this.modalController.dismiss();
		try {
			await this.modalController.dismiss();
			await this.modalController.dismiss();
			await this.navigationService.tos();
		} catch (e) {
			await this.navigationService.tos();
		}
	}

	async accessibility() {
		await this.modalController.dismiss();
		try {
			await this.modalController.dismiss();
			await this.modalController.dismiss();
			await this.navigationService.accessibility();
		} catch (e) {
			await this.navigationService.accessibility();
		}
	}

	async impressum() {
		try {
			await this.modalController.dismiss();
			await this.modalController.dismiss();
			await this.navigationService.imprint();
		} catch (e) {
			await this.navigationService.imprint();
		}
	}
	async allergens(event: Event) {
		event.preventDefault();
		await this.modalController.dismiss();
		console.log(this.translate.currentLang);
		if (this.translate.currentLang === 'en') {
			window.open('https://deananddavid.com/en/allergen-information/', '_blank');
		} else {
			window.open('https://deananddavid.com/allergenhinweis/', '_blank');
		}
		// TODO open PDF
	}

	dismiss() {
		this.modalController.dismiss();
	}
	changeLang(language: string) {
		this.translate.setDefaultLang(language);
		this.translate.use(language);
	}
	async willBeSoon() {
		await this.modalController.dismiss();

		this.snackbarCtrl.open('No design, will be soon...', null, {
			duration: 3000,
		});
	}
	async account() {
		await this.modalController.dismiss();

		this.navigationService.account();
	}
	async cookie() {
		await this.modalController.dismiss();

		this.navigationService.cookie();
	}
	async myPromo() {
		await this.modalController.dismiss();

		this.navigationService.promo();
	}
}
